import Client from '@/http/Client';

export default new Client();
